<template>
  <div class="module-container supervision-container">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <div class="d-flex flex-row justify-content-start align-items-center">
        <div
          class="main-image-container bg-purple rounded d-flex justify-content-center align-items-center"
        >
          <img
            height="25"
            width="25"
            :src="require('../../assets/icons/add-friend.svg')"
          />
        </div>
        <h3 class="mb-0 ml-3">Supervision Chart</h3>
      </div>
    </div>
    <hr />

    <div class="chart-content bg-white">
      <org-chart :data="data" @nodeClick="addClickEvent" @render="render" />
    </div>
    <div>
      <add-user-modal
        v-if="addSupervisionUserData.show"
        v-model="addSupervisionUserData.show"
        @addUserModalCancel="addUserModalCancel"
        @saveSuccessful="addUserModalSaveSuccessful"
        :filter="addSupervisionUserData.filter"
        :nameUser="addSupervisionUserData.nameUser"
        :nameOrganization="organization.name"
        :idOrganization="organization.id"
      />
    </div>
  </div>
</template>

<script>
import OrgChart from "../../third_party/org_chart/OrgChart.vue";
import systemSettingServer from "../../server/systemSetting";
import AddUserModal from "./AddSupervisionUserModal.vue";
import avatarServer from "../../server/avatar";
import supervisionServer from "../../server/supervision";
import { mapActions } from "vuex";
import { randomId } from "../../helpers/general";
export default {
  name: "SupervisionIndex",
  components: { OrgChart, AddUserModal },
  props: ["showing"],
  data() {
    return {
      data: [],
      organization: null,
      users: [],
      addSupervisionUserData: {
        show: false,
        filter: this.filter,
        nameUser: ""
      },
      buttonIds: [],
      filterType: {
        usersInSupervisionChart: "usersInSupervisionChart",
        usersWithoutSupervisor: "usersWithoutSupervisor",
        changeSupervisor: "changeSupervisor",
        addSupervisee: "addSupervisee"
      }
    };
  },

  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async fecthOrganization() {
      const response = await systemSettingServer.get();
      this.organization = {
        name: response.organizationName,
        imageUrl: response.organizationLogo
          ? response.organizationLogo
          : require(`../../assets/avatar-example.png`),
        id: response.id,
        isOrganization: true,
        parentId: null
      };
    },
    async fecthUsers(idOrganization) {
      const response = await supervisionServer.getSupervisionChartUsers(
        this.filter
      );
      if (response?.length > 0) {
        this.users = await Promise.all(
          response.map(async function(u) {
            let avatar = null;
            if (u.avatarId) {
              try {
                avatar = await avatarServer.downloadUrl(u.avatarId);
              } catch {
                //
              }
            }
            return {
              name: u.lastName + " " + u.firstName,
              imageUrl: avatar
                ? avatar
                : require(`../../assets/avatar-example.png`),
              id: u.id,
              isOrganization: false,
              parentId: u.supervisorUserId
                ? u.supervisorUserId
                : idOrganization,
              canSeeSuperviseesInfo: u.canSeeSuperviseesInfo
            };
          })
        );
      } else {
        this.users = [];
      }
    },
    render() {
      setTimeout(() => {
        this.clearHandlers(this.buttonIds);
        this.hookDropdownButtonsInSupervisonNodes();
      }, 0);
    },
    async fecthSupervisionChart() {
      var listNode = [];
      listNode.push(this.organization);
      await this.fecthUsers(this.organization.id);
      if (this.users?.length > 0) {
        this.users.forEach(u => {
          listNode.push(u);
        });
      }

      listNode = listNode.map(d => {
        const centerLeftDistance = 25;
        const actions = [
          {
            content: "Add supervisee",
            callback: () => {
              this.addSupervisionUserData = {
                show: true,
                filter: {
                  filter: this.filterType.addSupervisee,
                  userId: d.id
                },
                nameUser: d.name ? d.name : ""
              };
            }
          },
          {
            content: "Change supervisor",
            callback: () => {
              this.addSupervisionUserData = {
                show: true,
                filter: {
                  filter: this.filterType.changeSupervisor,
                  userId: d.id
                },
                nameUser: d.name ? d.name : ""
              };
            }
          },
          {
            content: "Remove",
            callback: () => {
              this.$dialog
                .alert(
                  {
                    title:
                      "Are you sure you want to delete this node, all their descendants will be removed?"
                  },
                  {
                    view: "confirm-delete"
                  }
                )
                .then(async () => {
                  let result = null;
                  result = await supervisionServer.removeSupervisor(d.id);
                  if (result.errorCode) {
                    this.$dialog.alert("Error: " + result.message);
                  } else {
                    await this.fecthSupervisionChart();
                    this.showAlertSuccess();
                  }
                });
            }
          }
        ];

        let buttonId = randomId(12);
        this.buttonIds.push(buttonId);
        return {
          nodeId: d.id,
          parentNodeId: d.parentId,
          isOrganization: d.isOrganization,
          backgroundColor: "#f5f8fc",
          color: "#616061",

          nodeImage: {
            url: d.imageUrl,
            width: d.isOrganization ? 60 : 50,
            height: d.isOrganization ? 60 : 50,
            centerLeftDistance: centerLeftDistance
          },

          template: d.isOrganization
            ? `<div style="flex-grow:2">
                        <div style="display: flex; flex-direction: row; justify-content: center;
                                    font-size:14px;
                                    font-weight:bold;
                              ">${d.name}
                          </div>
                </div>
                <div style="flex-grow:3">
                           <button  id="addUser" type="button" class="btn pb-0 pt-0 pl-3 pr-3 btn-primary btn-sm">Add User</button>
                </div>    `
            : `<div style="display: flex; flex-direction: column; justify-content: flex-start; height:45px; width: 250px;">
                 <div style="padding-left: 10px; flex-grow:2">
                       <div style="display: flex; flex-direction: row; justify-content: flex-start;" >
                              <div style="font-size:14px;font-weight:bold; flex-grow:6">
                                ${d.name}
                              </div>
                            ${this.createDropdownButton({
                              items: actions,
                              buttonId: buttonId,
                              menuWidth: 130,
                              noPadding: true
                            })}
                        </div>
                </div>
                    <div style="padding-left:30px;" class="custom-control custom-checkbox b-custom-control-sm">
                      <input type="checkbox" class="custom-control-input"  id="${
                        d.id
                      }" ${d.canSeeSuperviseesInfo ? "checked" : ""}
                        >
                        <label style="font-size:11px;" class="custom-control-label" for="${
                          d.id
                        }">
                          <p style="padding-top:2px">Can see information from supervisees</p>
                        </label>
                    </div>
              </div>`
        };
      });
      this.data = listNode;
    },
    async addClickEvent(id) {
      if (id != this.organization.id) {
        document.onclick = e => {
          this.captureElementNodeUserClick(e, id);
        };
      } else {
        document.onclick = e => {
          this.captureElementNodeOrganizationClick(e, "#addUser");
        };
      }
    },
    captureElementNodeOrganizationClick(e, element) {
      if (e.target.matches(element)) {
        this.addSupervisionUserData = {
          show: true,
          filter: {
            filter: this.filterType.usersWithoutSupervisor
          },
          nameUser: ""
        };
      }
    },
    async captureElementNodeUserClick(e, id) {
      if (e.target.id && e.target.id == id) {
        await supervisionServer.setSupervisor({
          userId: id,
          canSeeSuperviseesInfo: e.target.checked
        });
      }
    },
    async addUserModalSaveSuccessful() {
      this.addSupervisionUserData = {
        show: false,
        filter: null,
        nameUser: ""
      };
      await this.fecthSupervisionChart();
      this.showAlertSuccess();
    },
    async addUserModalCancel() {
      this.addSupervisionUserData = {
        show: false,
        filter: null,
        nameUser: ""
      };
    },
    positionChart(positionX, positionY) {
      var centerGroupElement = document.querySelector(".center-group");
      centerGroupElement.setAttribute(
        "transform",
        `translate(${positionX},${positionY}) scale(1)`
      );
    }
  },
  computed: {
    filter() {
      return {
        filter: this.filterType.usersInSupervisionChart,
        userId: null
      };
    }
  },
  watch: {
    showing: async function(newValue) {
      if (newValue) {
        await this.fecthOrganization();
        await this.fecthSupervisionChart();
        this.positionChart(
          document.querySelector(".chart-content").offsetWidth / 2,
          20
        );
      }
    }
  }
};
</script>

<style scoped>
.container-main {
  height: 100%;
}
.chart-content >>> .svg-chart-container {
  width: 100%;
}
</style>
